onComplete(function() {
	// A training's request link fills in which training the visitor asks about before the page scrolls to the form.
	document.addEventListener('click', function(event) {
		var link = event.target.closest('.training-request a');
		if (!link) {
			return;
		}
		var card = link.closest('.training-card');
		var heading = card ? card.querySelector('.training-content h3') : null;
		var form = document.querySelector('.request-form form');
		if (!heading || !form) {
			return;
		}
		form.querySelectorAll('label').forEach(function(label) {
			if (label.textContent.trim() !== 'Training') {
				return;
			}
			var input = document.getElementById(label.getAttribute('for'));
			if (input) {
				input.value = heading.textContent.trim();
			}
		});
	});

	// On an article the related items sit in a column next to the photo, so the column starts where the photo starts
	// instead of next to the full-width title above it.
	var article = document.querySelector('.blog-template-default.blog-item');
	if (article) {
		var alignRelated = function() {
			var photo = article.querySelector('.blog-content > [data-partial="image"]') || article.querySelector('.blog-item-content');
			if (!photo) {
				return;
			}
			article.style.removeProperty('--related-offset');
			var offset = photo.getBoundingClientRect().top - article.getBoundingClientRect().top;
			article.style.setProperty('--related-offset', Math.max(0, Math.round(offset)) + 'px');
		};
		alignRelated();
		window.addEventListener('resize', alignRelated);
		window.addEventListener('load', alignRelated);
	}
});
